import React from "react";
import { SortableContainer } from "react-sortable-hoc";

export const SortableContainerComponent = SortableContainer(
  ({ children }: any) => {
    return <ul style={{ padding: 0 }}>{children}</ul>;
  }
);
